/* QUIZ-JS (CRO-22, 28 Oct 2026): the cleanse quiz script, moved out of
   sections/quiz.liquid so it is cached instead of shipped inline on every
   page that has the quiz. Each quiz section pushes its settings and PICKS
   to window.PQ_CFG (inline, in the section); this file boots one quiz per
   config. Logic is unchanged; the Liquid values are read from the config. */
(function () {
  function boot(C) {
    var ROOT = C.root;
    var PICKS = C.picks || {};
    var AUTO = C.auto;
    var ADD_TO_CART = C.add_to_cart;
    var SHOW_LINK = C.show_link;
    var SHOW_PRICE = C.show_price;
    var ATC_LABEL = 'Add to cart'; /* BTN-28: each result sets its own (r.atc) */
    var ATC_BUSY = C.atc_busy;
    var ATC_DONE = C.atc_done;
    var FALLBACK = C.fallback;
    var MODAL = !!C.modal;

    function init() {
      var root = document.getElementById(ROOT);
      if (!root || root.dataset.pqInit === '1') return;
      root.dataset.pqInit = '1';

      var screens = {};
      [].slice.call(root.querySelectorAll('.pq-screen')).forEach(function (el) {
        screens[el.getAttribute('data-screen')] = el;
      });
      var branches = [].slice.call(root.querySelectorAll('[data-branch]'));
      var prog = root.querySelector('[data-pq-prog]');

      /* The whole state of the quiz. goalBranch is the number of the branch the
         chosen goal opens, or null when that goal is an outcome by itself. */
      var current = 'goal';
      var goalLabel = '';
      var goalBranch = null;
      var pickId = null;
      var pickLabel = '';
      var leadSent = false;
      var lead = { email: '', name: '' };

      function hasBranch() { return goalBranch !== null; }

      /* Three steps when the goal answers itself, four when it asks a follow
         up. Worked out from the actual path rather than counting the screens
         in the document, or a two step run would show the bar stalling at
         three quarters. */
      function stepInfo(name) {
        var total = hasBranch() ? 4 : 3;
        var at = 1;
        if (name === 'follow') at = 2;
        else if (name === 'capture') at = hasBranch() ? 3 : 2;
        else if (name === 'result') at = total;
        return { at: at, total: total };
      }

      function go(name) {
        current = name;
        Object.keys(screens).forEach(function (k) {
          screens[k].classList.toggle('is-active', k === name);
        });
        if (prog) {
          var st = stepInfo(name);
          prog.style.width = Math.round((st.at / st.total) * 100) + '%';
        }
        try {
          var top = root.getBoundingClientRect().top;
          if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {}
      }

      function showBranch(n) {
        branches.forEach(function (b) {
          var on = b.getAttribute('data-branch') === String(n);
          b.hidden = !on;
          if (!on) {
            /* Clear the answers on branches the shopper is not in, so going
               back and switching goals cannot carry an old pick forward. */
            [].slice.call(b.querySelectorAll('.pq-opt')).forEach(function (o) {
              o.setAttribute('aria-pressed', 'false');
            });
          }
        });
        var next = screens.follow.querySelector('[data-next]');
        if (next) next.disabled = true;
      }

      /* ---------- Answering ---------- */
      function wire(screenEl, onChoose) {
        var wrap = screenEl;
        var next = screenEl.querySelector('[data-next]');

        screenEl.addEventListener('click', function (e) {
          var o = e.target.closest ? e.target.closest('.pq-opt') : null;
          if (!o || !wrap.contains(o)) return;

          /* Single choice throughout. The Goal Finder never offered more than
             one answer and a branch cannot resolve two at once. */
          var group = o.closest('[data-opts]');
          [].slice.call(group.querySelectorAll('.pq-opt')).forEach(function (x) {
            x.setAttribute('aria-pressed', x === o ? 'true' : 'false');
          });

          onChoose(o);
          if (next) next.disabled = false;
          if (AUTO) {
            /* A beat, so the tick is seen before the screen changes. */
            setTimeout(advance, 220);
          }
        });

        if (next) next.addEventListener('click', advance);
      }

      function advance() {
        if (current === 'goal') {
          go(hasBranch() ? 'follow' : 'capture');
        } else if (current === 'follow') {
          go('capture');
        }
      }

      if (screens.goal) {
        wire(screens.goal, function (o) {
          goalLabel = o.getAttribute('data-label') || '';
          var br = o.getAttribute('data-branch');
          goalBranch = br ? br : null;
          if (goalBranch) {
            showBranch(goalBranch);
            /* The outcome now belongs to the follow up, not to the goal. */
            pickId = null;
            pickLabel = '';
          } else {
            pickId = o.getAttribute('data-pick');
            pickLabel = '';
          }
        });
      }

      if (screens.follow) {
        wire(screens.follow, function (o) {
          pickId = o.getAttribute('data-pick');
          pickLabel = o.getAttribute('data-label') || '';
        });
      }

      root.querySelectorAll('[data-back]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (current === 'capture') go(hasBranch() ? 'follow' : 'goal');
          else if (current === 'follow') go('goal');
        });
      });

      /* ---------- Klaviyo ---------- */
      function kIdentify(p) {
        if (window._learnq) { try { window._learnq.push(['identify', p]); } catch (e) {} }
      }
      function kTrack(name, p) {
        if (window._learnq) { try { window._learnq.push(['track', name, p]); } catch (e) {} }
      }
      function kSubscribe(attrs) {
        var list = root.getAttribute('data-klaviyo-list');
        var company = root.getAttribute('data-klaviyo-company');
        if (!list || list.length <= 2 || !company) return;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + company, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: attrs } },
                custom_source: C.klaviyo_source
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        }).catch(function () {});
      }

      /* ---------- Result ---------- */
      function answerLine() {
        return pickLabel ? (goalLabel + ' › ' + pickLabel) : goalLabel;
      }

      function paintResult(r) {
        var img = root.querySelector('[data-r-img]');
        var media = root.querySelector('[data-r-media]');
        var priceEl = root.querySelector('[data-r-price]');
        var pathEl = root.querySelector('[data-r-path]');

        if (media) media.style.display = (r && r.image) ? '' : 'none';
        if (img && r && r.image) { img.src = r.image; img.alt = r.title || ''; }

        root.querySelector('[data-r-name]').textContent = (r && r.title) || '';
        root.querySelector('[data-r-why]').textContent = (r && r.why) || '';

        /* Hidden rather than emptied, so an outcome pointing at a collection
           does not leave a gap where a price would be. */
        if (priceEl) {
          priceEl.textContent = (r && r.price) || '';
          priceEl.hidden = !(r && r.price);
        }

        if (pathEl) {
          pathEl.innerHTML = '';
          [goalLabel, pickLabel].forEach(function (t) {
            if (!t) return;
            var b = document.createElement('b');
            b.textContent = t;
            pathEl.appendChild(b);
          });
          pathEl.hidden = !goalLabel;
        }

        var cta = root.querySelector('[data-r-cta]');
        if (cta) cta.href = (r && r.url && r.url !== '#') ? r.url : FALLBACK.url;

        paintBuy(r);
      }

      /* ---------- Buy from the result ----------
         A cleanse can be added without leaving the quiz, which matters most in
         the modal, where sending someone to a product page throws away the
         flow they just completed. Outcomes that are a collection link, a
         subscription product, or have nothing in stock keep the link instead. */
      var buyRow = root.querySelector('[data-r-buy]');
      var varSel = root.querySelector('[data-r-variant]');
      var varLabel = root.querySelector('[data-r-varlabel]');
      var atcBtn = root.querySelector('[data-r-atc]');
      var atcErr = root.querySelector('[data-r-atc-err]');
      var ctaBtn = root.querySelector('[data-r-cta]');
      var priceEl = root.querySelector('[data-r-price]');

      function inStock(r) {
        return !!(r && r.variants && r.variants.some(function (v) { return v.available; }));
      }

      function paintBuy(r) {
        if (!buyRow) return;
        var canBuy = ADD_TO_CART && r && r.variants && r.variants.length && inStock(r) && !r.requires_options;
        buyRow.hidden = !canBuy;
        if (atcErr) { atcErr.textContent = ''; atcErr.classList.remove('is-shown'); }
        if (r && r.atc) ATC_LABEL = r.atc; /* BTN-28 */
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = ATC_LABEL; }

        /* With a buy button on screen the link becomes the quieter of the two,
           and it disappears entirely if it has been turned off. */
        if (ctaBtn) {
          ctaBtn.hidden = canBuy && !SHOW_LINK;
          ctaBtn.classList.toggle('pq-btn--ghost', canBuy);
        }
        if (!canBuy) return;

        var opts = r.variants.filter(function (v) { return v.available; });
        /* An answer that named its own variant has already chosen for the
           shopper, so no picker is shown. */
        var fixed = null;
        if (r.variant_id) {
          r.variants.forEach(function (v) {
            if (String(v.id) === String(r.variant_id) && v.available) fixed = v;
          });
          if (fixed) opts = [fixed];
        }
        var many = opts.length > 1;
        if (varSel) {
          varSel.innerHTML = '';
          opts.forEach(function (v) {
            var o = document.createElement('option');
            o.value = v.id;
            o.textContent = v.title + (v.price ? '  ' + v.price : '');
            varSel.appendChild(o);
          });
          varSel.hidden = !many;
          varSel.onchange = syncPrice;
        }
        if (varLabel) varLabel.hidden = !many;
        syncPrice();
      }

      function selectedVariant() {
        var r = pickId ? PICKS[pickId] : null;
        if (!r || !r.variants || !r.variants.length) return null;
        var id = varSel && varSel.value ? String(varSel.value) : null;
        var match = null;
        r.variants.forEach(function (v) {
          if (String(v.id) === id) match = v;
        });
        if (match) return match;
        for (var i = 0; i < r.variants.length; i++) {
          if (r.variants[i].available) return r.variants[i];
        }
        return null;
      }

      function syncPrice() {
        if (!priceEl || !SHOW_PRICE) return;
        var v = selectedVariant();
        if (v && v.price) {
          priceEl.textContent = v.price;
          priceEl.hidden = false;
        }
      }

      if (atcBtn) {
        atcBtn.addEventListener('click', function () {
          var v = selectedVariant();
          if (!v) return;
          atcBtn.disabled = true;
          atcBtn.textContent = ATC_BUSY;
          if (atcErr) { atcErr.textContent = ''; atcErr.classList.remove('is-shown'); }

          var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
          fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          })
            .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, body: j }; }); })
            .then(function (out) {
              if (!out.ok) {
                if (atcErr) {
                  atcErr.textContent = (out.body && (out.body.description || out.body.message)) || 'Sorry, that could not be added.';
                  atcErr.classList.add('is-shown');
                }
                atcBtn.disabled = false;
                atcBtn.textContent = ATC_LABEL;
                return;
              }
              atcBtn.textContent = ATC_DONE;
              if (MODAL) closeModal();
              document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
                bubbles: true, cancelable: false, detail: { openDrawer: true }
              }));
              setTimeout(function () {
                atcBtn.disabled = false;
                atcBtn.textContent = ATC_LABEL;
              }, 2000);
            })
            .catch(function () {
              if (atcErr) {
                atcErr.textContent = 'Sorry, that could not be added.';
                atcErr.classList.add('is-shown');
              }
              atcBtn.disabled = false;
              atcBtn.textContent = ATC_LABEL;
            });
        });
      }

      /* ---------- Capture ---------- */
      var emailEl = root.querySelector('[data-pq-email]');
      var nameEl = root.querySelector('[data-pq-name]');
      var errEl = root.querySelector('[data-pq-err]');
      var submit = root.querySelector('[data-submit]');

      function valid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

      if (submit) {
        submit.addEventListener('click', function () {
          var email = (emailEl.value || '').trim();
          if (!valid(email)) { errEl.classList.add('is-shown'); emailEl.focus(); return; }
          errEl.classList.remove('is-shown');
          lead.email = email;
          lead.name = nameEl ? (nameEl.value || '').trim() : '';

          /* An outcome with no product and no link has nothing to show. Rather
             than painting an empty card, fall back to something real. */
          var r = pickId ? PICKS[pickId] : null;
          if (!r) r = FALLBACK;

          if (!leadSent) {
            leadSent = true;
            try {
              var id = { '$email': lead.email, 'Quiz - Completed': true };
              if (lead.name) id['$first_name'] = lead.name;
              if (r) id['Quiz - Recommended'] = r.title;
              id['Quiz - Goal'] = goalLabel;
              id['Quiz - Answer'] = pickLabel;
              kIdentify(id);
              kTrack(C.klaviyo_event, {
                'Email': lead.email,
                'Name': lead.name,
                'Goal': goalLabel,
                'Answer': pickLabel,
                'Path': answerLine(),
                'Recommended': r ? r.title : ''
              });
              kSubscribe({
                email: lead.email,
                first_name: lead.name,
                properties: {
                  'Quiz - Goal': goalLabel,
                  'Quiz - Answer': pickLabel,
                  'Quiz - Recommended': r ? r.title : ''
                }
              });
            } catch (e) {}
          }

          paintResult(r);
          go('result');
        });

        [emailEl, nameEl].forEach(function (el) {
          if (!el) return;
          el.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); submit.click(); }
          });
        });
      }

      var code = root.querySelector('[data-pq-code]');
      if (code) {
        code.addEventListener('click', function () {
          var t = code.textContent;
          if (navigator.clipboard) navigator.clipboard.writeText(t.trim()).catch(function () {});
          code.textContent = C.copied_label;
          setTimeout(function () { code.textContent = t; }, 1600);
        });
      }

      var restart = root.querySelector('[data-restart]');
      if (restart) {
        restart.addEventListener('click', function () {
          root.querySelectorAll('.pq-opt').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          root.querySelectorAll('[data-next]').forEach(function (b) { b.disabled = true; });
          branches.forEach(function (b) { b.hidden = true; });
          goalLabel = ''; pickLabel = ''; goalBranch = null; pickId = null;
          go('goal');
        });
      }

      /* Capture phase, so a theme handler on the same link cannot also fire. */
      var scrim = document.querySelector('.pq-scrim');
      function openModal() {
        root.classList.add('is-open');
        if (scrim) scrim.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
      }
      function closeModal() {
        root.classList.remove('is-open');
        if (scrim) scrim.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
      if (MODAL) {
      var SEL = C.trigger_selector || '[data-pq-open]';
      document.addEventListener('click', function (e) {
        var hit = null;
        try { hit = e.target.closest(SEL); } catch (err) { return; }
        if (!hit || root.contains(hit)) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        openModal();
      }, true);
      root.querySelectorAll('[data-pq-close]').forEach(function (b) {
        b.addEventListener('click', closeModal);
      });
      if (scrim) scrim.addEventListener('click', closeModal);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-open')) closeModal();
      });
      }

      go('goal');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }

    document.addEventListener('shopify:section:load', function () {
      var r = document.getElementById(ROOT);
      if (r) { r.dataset.pqInit = ''; init(); }
    });
  }
  var Q = window.PQ_CFG = window.PQ_CFG || [];
  for (var i = 0; i < Q.length; i++) boot(Q[i]);
  Q.push = function () { for (var k = 0; k < arguments.length; k++) { Array.prototype.push.call(Q, arguments[k]); boot(arguments[k]); } return Q.length; };
})();